import React, {Component} from 'react';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { toggleAlertHandler } from "../../../actions";
import View from "./customizedAlert";

class CustomizedAlert extends Component {
    constructor(props) {
        super(props);
        this.closeAlert = this.closeAlert.bind(this);
    }

    closeAlert() {
        const alertObj = {
            alert: false,
            message: "",
            type: "error"
        };

        this.props.toggleAlertHandler(alertObj);
    }

    render(){
        const { toggleAlert } = this.props;
        return (
            <View toggleAlert = {toggleAlert}
                  closeAlert = {this.closeAlert}/>
        )
    }
}

function mapStateToProps(state){
    return{
        toggleAlert: state.feedback.toggleAlert
    }
}

export default withRouter(connect(mapStateToProps, {
    toggleAlertHandler
})(CustomizedAlert));

